import { Injectable } from '@angular/core';
import type { DropdownMenuComponent } from './dropdown-menu.component';

@Injectable({
  providedIn: 'root',
})
export class DropdownMenuService {
  private dropdownMenus: DropdownMenuComponent[] = [];

  registerDropdown(dropdownMenu: DropdownMenuComponent) {
    this.dropdownMenus.push(dropdownMenu);
  }

  unregisterDropdown(dropdownMenu: DropdownMenuComponent) {
    this.dropdownMenus.splice(this.dropdownMenus.indexOf(dropdownMenu), 1);
  }

  hideAllMenusExcept(excludedDropdownMenu?: DropdownMenuComponent) {
    this.dropdownMenus.forEach((dropdownMenu) => excludedDropdownMenu !== dropdownMenu && dropdownMenu.hideMenu());
  }
}
